import { min } from 'lib/array/arrayUtils'
import { LUX_LOYALTY } from 'luxLoyalty/constants/base'

/** Gets the default / lowest ranked tier from program config */
export function getLuxLoyaltyDefaultTier(state: App.State): App.LuxLoyaltyTier {
  const configDetails = state.luxLoyalty.programConfig.configDetails
  if (!configDetails) return LUX_LOYALTY.DEFAULT_TIER

  const tiers = Object.values(configDetails.tiers)
  return min(tiers, tier => tier.sortingOrder)!.tierName as App.LuxLoyaltyTier
}
